export default __webpack_public_path__ + "static/teams-c4025a9e5d59c86c820850d45e279971.png";